import _ from 'lodash';

export default angular
  .module('doxy.videoChat.common.directives.toggleControlsOnTimeout', [])
  .directive('toggleControlsOnTimeout', function ($document) {
    return {
      restrict: 'A',
      scope: false,
      link: function (scope, elem, attr) {
        scope.mouseOver = false;

        elem[0].onmouseenter = () => {
          scope.mouseOver = true;
        };

        elem[0].onmouseleave = elem[0].ontouchend = () => {
          scope.mouseOver = false;
        };

        const delay = +attr.toggleControlsOnTimeout || 5000;
        const inactiveClass = attr.inactiveClass || 'mod-inactive';

        const turnInactive = _.debounce(
          function () {
            if (!scope.mouseOver) elem.addClass(inactiveClass);
          },
          delay,
          { leading: false, trailing: true }
        );

        const turnActive = _.debounce(
          function () {
            elem.removeClass(inactiveClass);
          },
          delay,
          { leading: true, trailing: false }
        );

        function toggleActive() {
          turnInactive();
          turnActive();
        }

        $document.bind('mousemove', toggleActive);
        $document.bind('touchstart', toggleActive);

        scope.$on('$destroy', function () {
          $document.unbind('mousemove', toggleActive);
          $document.unbind('touchstart', toggleActive);
        });
      },
    };
  }).name;
